<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id" />
		<div class="p-l-24 p-r-24 p-d-24" :id="id" style="display: none">
      <SOInputCheckbox :checkboxes="statusGaji" @selected="selected" :checked="filterItem.statusGaji" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterStatusGaji",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
    title:{
      type: String,
      default: "Status"
    },
    dataOptions: {
      type: Array,
      default: function () {
        return [
					{
						id: "fstatgaji-1",
						value: "1",
						title: "Dengan Tanggungan",
						checked: false,
						titleBold: false,
					},
					{
						id: "fstatgaji-2",
						value: "2",
						title: "Tanpa Tanggungan",
						checked: false,
						titleBold: false,
					},
				];
      }
    }
	},
	data() {
		return {
			statusGaji: {
				name: "status-gaji",
				data: this.dataOptions,
			},
      diterapkan: false,
		}
	},
  mounted() {
    this.diterapkan = this.filterItem.statusGaji.length > 0;
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem",
    }),
  },
	methods: {
		selected(val) {
      let temp = this.filterItem;
      temp.statusGaji = val;
      this.$store.commit("filterGlobalModule/setFilterItem", temp);
      this.diterapkan = this.filterItem.statusGaji.length > 0;
		}
	}
}
</script>